import IframeKBBDealerRatings from './IframeKBBDealerRatings';

export default IframeKBBDealerRatings;
